<script>
import Card from '../../../Components/Card.vue';
import { toRaw } from 'vue';

export default {
  components: { Card },

  props: {
    masterConfig: Object,
    kioskKey: String,
  },

  emits: ['ready', 'update', 'next'],

  data() {
    return {};
  },

  created() {},

  mounted() {
    this.setupTireConnect();
  },

  methods: {
    updateTireConnect(data, autoAdvance = false) {
      this.$emit('update', {
        tireConnectData: data,
      });
      this.$emit('ready', true);
      if (autoAdvance) {
        this.$nextTick(() => {
          this.$emit('next');
        });
      }
    },

    setupTireConnect() {
      let vm = this;
      axios
        .post(
          route('scheduler.tireconnect', {
            key: this.kioskKey,
          }),
        )
        .then((response) => {
          let config = toRaw(response.data.data);
          TCWidget.init(config).then(function (widget) {
            widget.on('onAppointmentClick', function (event) {
              console.log('[TC] onAppointmentClick', { status: event.status, data: event.data });
              // Reject TC's own booking flow — scheduler handles it
              // Only tire/quote data is available here (no customer yet)
              event.reject();
              vm.updateTireConnect(event.data);
            });
            widget.on('onOrderSubmitted', function (event) {
              console.log('[TC] onOrderSubmitted', { status: event.status, data: event.data });
              // Resolve (not reject) so TC's widget can clear its own PLEASE WAIT overlay.
              event.resolve();
              vm.updateTireConnect(event.data, true);
            });
            widget.on('onEcommerceOrder', function (event) {
              // TC docs say check event.status; some event shapes put it inside event.data instead.
              const isSubmitted =
                event.status === 'submitted' || event.data?.status === 'submitted';
              console.log('[TC] onEcommerceOrder', {
                status: event.status,
                dataStatus: event.data?.status,
                isSubmitted,
                data: event.data,
              });
              event.resolve();
              if (isSubmitted) {
                vm.updateTireConnect(event.data, true);
              }
            });
          });
        });
    },
  },
};
</script>

<template>
  <Card class="mt-3">
    <div id="tireconnectContainer" />
  </Card>
</template>
